import { ApplicationType } from '@thesavingsgroup/enums/ApplicationType';

import { RefinanceGoal } from '../enums/RefinanceGoal';
import { ApplyState } from '../types/ApplyState';
import { HydrateFromMailCode } from '../types/HydrateFromMailCode';

export const toApplyStateFromMailCode = (
  params: HydrateFromMailCode,
): Partial<ApplyState> => {
  const { payoffAmount } = params;

  return {
    applicationType: ApplicationType.REFINANCE,
    isHydrated: true,
    payoffAmount,
    refinanceGoal: RefinanceGoal.LOWER_PAYMENT,
  };
};
